export enum SpsLocationRegionEnum {
  ALL = 'ALL',
  EMEA = 'EMEA',
  APAC = 'APAC',
  NA = 'NA',
}
